import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "cinput-title" }
const _hoisted_2 = ["value", "required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["cinput-container", {active: _ctx.modelValue || _ctx.focused, error: !_ctx.status}]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tInput?.focus()))
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.placeholder), 1),
      _createElementVNode("input", {
        class: "input",
        ref: "tInput",
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.focused=true)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focused=false)),
        type: "text",
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateVal($event))),
        value: _ctx.modelValue,
        required: _ctx.required
      }, null, 40, _hoisted_2)
    ], 2),
    (_ctx.hint?.length && !_ctx.status)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["hint", {error: !_ctx.status}])
        }, _toDisplayString(_ctx.hint), 3))
      : _createCommentVNode("", true)
  ], 64))
}